/**
 * TaskPortalNoteService
 * Service for task note operations in the portal.
 * Route: api/task-portal/tasks/{taskId}/notes
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
/**
 * TaskPortalNoteService
 * Handles note operations for the task portal.
 * Creators: Can see all notes, CRUD any note
 * Assignees: Can only see and manage their own notes
 */
export class TaskPortalNoteService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalNoteService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? TaskPortalNoteService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get notes for a task
     * GET /api/task-portal/tasks/{taskId}/notes
     * Creators: See all notes
     * Assignees: Only see their own notes
     */
    async getNotes(taskId) {
        const response = await this.getNotesRaw(taskId);
        return response.data ?? [];
    }
    getNotesRaw(taskId) {
        return this.get(`${taskId}/notes`);
    }
    /**
     * Get a specific note
     * GET /api/task-portal/tasks/{taskId}/notes/{noteId}
     */
    async getNote(taskId, noteId) {
        const response = await this.getNoteRaw(taskId, noteId);
        if (!response.data) {
            throw new Error(`Note ${noteId} not found`);
        }
        return response.data;
    }
    getNoteRaw(taskId, noteId) {
        return this.get(`${taskId}/notes/${noteId}`);
    }
    /**
     * Create a new note
     * POST /api/task-portal/tasks/{taskId}/notes
     */
    async createNote(taskId, data) {
        const response = await this.createNoteRaw(taskId, data);
        if (!response.data) {
            throw new Error('Failed to create note');
        }
        return response.data;
    }
    createNoteRaw(taskId, data) {
        return this.post(`${taskId}/notes`, data);
    }
    /**
     * Update a note
     * PUT /api/task-portal/tasks/{taskId}/notes/{noteId}
     * Creators: Can update any note
     * Assignees: Can only update their own notes
     */
    async updateNote(taskId, noteId, data) {
        const response = await this.updateNoteRaw(taskId, noteId, data);
        if (!response.data) {
            throw new Error('Failed to update note');
        }
        return response.data;
    }
    updateNoteRaw(taskId, noteId, data) {
        return this.put(`${taskId}/notes/${noteId}`, data);
    }
    /**
     * Delete a note
     * DELETE /api/task-portal/tasks/{taskId}/notes/{noteId}
     * Creators: Can delete any note
     * Assignees: Can only delete their own notes
     */
    async deleteNote(taskId, noteId) {
        const response = await this.deleteNoteRaw(taskId, noteId);
        if (!response.success) {
            throw new Error('Failed to delete note');
        }
    }
    deleteNoteRaw(taskId, noteId) {
        return this.delete(`${taskId}/notes/${noteId}`);
    }
}
TaskPortalNoteService.DEFAULT_SERVICE_PATH = 'tasks';
TaskPortalNoteService.BASE_PATH = 'api/task-portal/tasks';
//# sourceMappingURL=TaskPortalNoteService.js.map